export const isSsr = () => typeof window === 'undefined';
export const isBrowser = () => typeof window !== 'undefined';

export const getWindowObj = () => (typeof window === 'object' ? window : {});
